export const SPECIAL_TYPE = {
  BY_FAMILY_GROUP: 'BY_FAMILY_GROUP',
  BY_PRODUCT: 'BY_PRODUCT'
}

export const PROMOTION_TYPE = {
  BY_FAMILY_GROUP: 'BY_FAMILY_GROUP',
  BY_PRODUCT: 'BY_PRODUCT'
}

export const TARGET_TYPE = {
  NATIONAL: 'NATIONAL',
  BANNER_GROUP: 'BANNER_GROUP',
  MULTI_STORE_OPERATOR: 'MULTI_STORE_OPERATOR',
  RETAILER_STORE: 'RETAILER_STORE'
}

export const TARGET_TYPES = [
  { text: 'ALL Zones', value: TARGET_TYPE.NATIONAL },
  { text: 'Banner Group(s)', value: TARGET_TYPE.BANNER_GROUP },
  { text: 'Multi-Store Operator(s)', value: TARGET_TYPE.MULTI_STORE_OPERATOR },
  { text: 'Retailer(s)', value: TARGET_TYPE.RETAILER_STORE }
]
